/**
 * BETA banner — flag-gated, OFF by default.
 *
 * Renders a full-width notice strip ONLY when VITE_BETA_BANNER === 'true' (set at build time for the
 * gated beta deployment). For GA, leave the flag unset/false: the component is a no-op (renders null)
 * — no layout impact, no runtime cost, so flipping beta off is a single build-env change. Pairs with
 * the edge gate (Cloudflare Access + the X-Robots-Tag: noindex API middleware).
 */
export function BetaBanner() {
  if (import.meta.env.VITE_BETA_BANNER !== 'true') return null

  return (
    <div
      role="status"
      aria-label="Beta environment notice"
      style={{
        width: '100%',
        // viewport-fit=cover paints edge-to-edge; this banner is the topmost element, so it consumes the
        // top safe-area inset (status bar / notch) — the yellow fills the inset area and the text clears it.
        // No-op where there's no inset (env → 0, e.g. Samsung A54 hole-punch) since it collapses to 8px.
        padding: 'calc(8px + env(safe-area-inset-top)) 16px 8px',
        textAlign: 'center',
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: 1.4,
        color: '#1a1a1a',
        background: '#ffd24d',
        borderBottom: '1px solid #d4a017',
      }}
    >
      ⚠️ BETA — test environment. Balances and history may be reset at any time. Do not rely on it for production use.
    </div>
  )
}
